export default __webpack_public_path__ + "static/media/motilal-oswal.8c02f459.png";